export const enum ParkingaboProductType {
    ALL_ACCESS = 'ALL_ACCESS',
    GUEST_PERMIT_VALID_TO = 'GUEST_PERMIT_VALID_TO',
    GUEST_RESERVATION = 'GUEST_RESERVATION',
    GUEST_RESERVATION_UBS = 'GUEST_RESERVATION_UBS',
    PERMIT_FREE_FIXED_DURATION = 'PERMIT_FREE_FIXED_DURATION',
    PERMIT_FREE_VALID_TO = 'PERMIT_FREE_VALID_TO',
    PERMIT_UNTIL_REVOCATION = 'PERMIT_UNTIL_REVOCATION',
    RESERVATION = 'RESERVATION',
    SUBSCRIPTION = 'SUBSCRIPTION',
    GUEST_DAY_PASS = 'GUEST_DAY_PASS',
}
